import { Client } from "./client";
import httpClient from "@/httpclient/httpclient";
const apiClient = new Client('', httpClient);
export { httpClient, apiClient };
